import { render } from "./ContactScreen.vue?vue&type=template&id=9001d4c8&scoped=true"
import script from "./ContactScreen.vue?vue&type=script&lang=js"
export * from "./ContactScreen.vue?vue&type=script&lang=js"

import "./ContactScreen.vue?vue&type=style&index=0&id=9001d4c8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9001d4c8"]])

export default __exports__